// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-dashboard-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.new-dashboard-container{
    width: 32vw;
    background-color: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
}
.new-dashboard-container .new-dashboard-header{
    margin: 0px;
    padding: 10px 25px;
    width: 100%;
    border-radius: 5px 5px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
}
.new-dashboard-container .new-dashboard-header h3{
    margin: 0px;
    color: white;
    font-size: 22px;
    font-weight: 600;
}
.new-dashboard-container .new-dashboard-header p{
    margin: 0px;
    color: white;
    cursor: pointer;
    font-size: 22px;
    font-weight: 400;
}
.new-dashboard-container .new-dashboard-body{
    padding: 10px 25px;
}
.new-dashboard-property-component{
    position: relative;
    margin: 20px 0px;
    padding: 4px 10px;
    border-radius: 2px;
    box-sizing: border-box;
    background-color: rgba(222, 229, 233, 0.6);
    border-bottom: 1px solid rgb(185, 185, 185);
}
.new-dashboard-property-component:focus-within{
    border-bottom: 1px solid rgba(155, 30, 30, 0.952);
}
.new-dashboard-property-component p{
    margin: 0px;
    font-size: 10px;
    color: gray;
}
.new-dashboard-property-component p span{
    color: red;
}
.new-dashboard-property-component input{
    width: 100%;
    outline: none;
    border: none;
    background-color: transparent;
}
.new-dashboard-property-component .assigned-customers-entry-container{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.new-dashboard-property-component .assigned-customers-entry-container .customer-entry{
    margin: 4px 6px;
    padding: 4px 10px;
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    border-radius: 16px;
    color: rgb(59, 59, 59);
    background-color: rgb(204, 210, 218);
}
.new-dashboard-property-component .assigned-customers-entry-container .customer-entry p{
    font-size: 14px;
    cursor: pointer;
    margin-left: 8px;
}
.new-dashboard-property-component .assigned-customers-entry-container input{
    flex: 1 1;
    min-width: 100px;
    margin: 4px 6px;
    display: inline-flex;
}
.new-dashboard-property-component .customers-browser-container{
    position: absolute;
    z-index: 1;
    top: 100%;
    max-height: 24vh;
    overflow-y: auto;
    width: 100%;
    display: none;
    margin-top: 2px;
    box-sizing: border-box;
    transform: translateX(-10px);
    background-color: white;
    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);
    border-radius: 0px 0px 4px 4px;
}
.new-dashboard-property-component .customers-browser-container.active{
    display: block;
}
.new-dashboard-property-component .customers-browser-container div{
    padding: 10px 12px;
    cursor: pointer;
    box-sizing: border-box;
    border-bottom: 1px solid rgb(230, 230, 230);
    transition: background-color 0.25s ease;
}
.new-dashboard-mobile-settings-container{
    padding: 15px;
    border-radius: 5px;
    border: 1px solid lightgray;
}
.new-dashboard-mobile-settings-container h4{
    margin: 0px;
    font-weight: 600;
}
.new-dashboard-mobile-settings-container .hide-dashboard-container{
    display: flex;
    align-items: center;
    padding-top: 16px;
    margin-bottom: 0px;
    padding-bottom: 0px;
}
.new-dashboard-mobile-settings-container .hide-dashboard-container p{
    margin: 0px;
}
.new-dashboard-property-component .mobile-order-entry-container input{
    font-size: 14px;
    padding-top: 4px;
}
.new-dashboard-mobile-settings-container .dashboard-image-container .header{
    color: rgb(112, 112, 112);
    font-size: 14px;
}
.new-dashboard-mobile-settings-container .dashboard-image-container .body{
    display: grid;
    grid-template-columns: 100px auto;
}
.new-dashboard-mobile-settings-container .dashboard-image-container div{
    box-shadow: 0px 0px 1px rgb(97, 97, 97);
}
.new-dashboard-mobile-settings-container .dashboard-image-container .image-container{
    display: flex;
    align-items: center;
    justify-content: center;
}
.new-dashboard-mobile-settings-container .dashboard-image-container .image-container img{
    max-width: 80px;
    max-height: 80px;
}
.new-dashboard-mobile-settings-container .dashboard-image-container .upload-controls-container{
    display: flex;
    flex-direction: column;
    margin: 6px 10px;
    padding: 10px 0px;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    transition: background-color 0.25s ease;
    box-shadow: 0px 0px 1px rgb(97, 97, 97);
}
.new-dashboard-mobile-settings-container .dashboard-image-container .upload-controls-container.inactive{
    display: none;
}
.new-dashboard-mobile-settings-container .dashboard-image-container .upload-controls-container:hover{
    background-color: rgb(248, 248, 250);
}
.new-dashboard-mobile-settings-container .dashboard-image-container .upload-controls-container img{
    height: 40px;
}
.new-dashboard-mobile-settings-container .dashboard-image-container .upload-controls-container p{
    margin: 4px 0px;
    font-size: 14px;
    color: rgb(48, 48, 48);
}
.new-dashboard-mobile-settings-container .dashboard-image-container .uploaded-controls-container{
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: none;
    box-shadow: none;
}
.new-dashboard-mobile-settings-container .dashboard-image-container .uploaded-controls-container.inactive{
    display: none;
}
.new-dashboard-mobile-settings-container .dashboard-image-container .uploaded-controls-container div{
    box-shadow: none;
}
.new-dashboard-mobile-settings-container .dashboard-image-container .uploaded-controls-container div p{
    margin: 0px;
}
.new-dashboard-mobile-settings-container .dashboard-image-container .uploaded-controls-container .image-name-p{
    font-size: 14px;
    color: rgb(90, 90, 90);
}
.new-dashboard-mobile-settings-container .dashboard-image-container .uploaded-controls-container .image-size-p{
    font-size: 13px;
    color: rgb(145, 145, 145);
}
.new-dashboard-mobile-settings-container .dashboard-image-container .uploaded-controls-container .remove-image-p{
    cursor: pointer;
    color: rgb(100, 100, 100);
}
.new-dashboard-container-buttons{
    width: 100%;
    padding: 20px 50px;
    padding-right: 13px;
    text-align: right;
    box-sizing: border-box;
}
.new-dashboard-container-buttons button{
    padding: 10px 25px;
    margin: 0px 10px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    color: white;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
    background-color: rgba(155, 30, 30, 0.952);
    transition: opacity 0.2s ease;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.new-dashboard-container-buttons button:hover{
    opacity: 0.9;
}
.new-dashboard-container-buttons button.inactive{
    opacity: 0.6;
    box-shadow: none;
    cursor: not-allowed;
    color: rgb(136, 136, 136);
    background-color: rgb(201, 201, 201);
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Dashboards/NewDashboard.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,4DAA4D;AAChE;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,sCAAsC;IACtC,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B,0CAA0C;IAC1C,sBAAsB;IACtB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;IACtB,0CAA0C;IAC1C,2CAA2C;AAC/C;AACA;IACI,iDAAiD;AACrD;AACA;IACI,WAAW;IACX,eAAe;IACf,WAAW;AACf;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,oCAAoC;AACxC;AACA;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,SAAO;IACP,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IACvB,6CAA6C;IAC7C,8BAA8B;AAClC;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,2CAA2C;IAC3C,uCAAuC;AAC3C;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,aAAa;IACb,iCAAiC;AACrC;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,uCAAuC;IACvC,uCAAuC;AAC3C;AACA;IACI,aAAa;AACjB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,sCAAsC;IACtC,0CAA0C;IAC1C,6BAA6B;IAC7B,4DAA4D;AAChE;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;AACxC","sourcesContent":[".new-dashboard-parent-container{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 10;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n    font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.new-dashboard-container{\r\n    width: 32vw;\r\n    background-color: white;\r\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n    border-radius: 5px;\r\n}\r\n.new-dashboard-container .new-dashboard-header{\r\n    margin: 0px;\r\n    padding: 10px 25px;\r\n    width: 100%;\r\n    border-radius: 5px 5px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n.new-dashboard-container .new-dashboard-header h3{\r\n    margin: 0px;\r\n    color: white;\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n}\r\n.new-dashboard-container .new-dashboard-header p{\r\n    margin: 0px;\r\n    color: white;\r\n    cursor: pointer;\r\n    font-size: 22px;\r\n    font-weight: 400;\r\n}\r\n.new-dashboard-container .new-dashboard-body{\r\n    padding: 10px 25px;\r\n}\r\n.new-dashboard-property-component{\r\n    position: relative;\r\n    margin: 20px 0px;\r\n    padding: 4px 10px;\r\n    border-radius: 2px;\r\n    box-sizing: border-box;\r\n    background-color: rgba(222, 229, 233, 0.6);\r\n    border-bottom: 1px solid rgb(185, 185, 185);\r\n}\r\n.new-dashboard-property-component:focus-within{\r\n    border-bottom: 1px solid rgba(155, 30, 30, 0.952);\r\n}\r\n.new-dashboard-property-component p{\r\n    margin: 0px;\r\n    font-size: 10px;\r\n    color: gray;\r\n}\r\n.new-dashboard-property-component p span{\r\n    color: red;\r\n}\r\n.new-dashboard-property-component input{\r\n    width: 100%;\r\n    outline: none;\r\n    border: none;\r\n    background-color: transparent;\r\n}\r\n.new-dashboard-property-component .assigned-customers-entry-container{\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n}\r\n.new-dashboard-property-component .assigned-customers-entry-container .customer-entry{\r\n    margin: 4px 6px;\r\n    padding: 4px 10px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    border-radius: 16px;\r\n    color: rgb(59, 59, 59);\r\n    background-color: rgb(204, 210, 218);\r\n}\r\n.new-dashboard-property-component .assigned-customers-entry-container .customer-entry p{\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    margin-left: 8px;\r\n}\r\n.new-dashboard-property-component .assigned-customers-entry-container input{\r\n    flex: 1;\r\n    min-width: 100px;\r\n    margin: 4px 6px;\r\n    display: inline-flex;\r\n}\r\n.new-dashboard-property-component .customers-browser-container{\r\n    position: absolute;\r\n    z-index: 1;\r\n    top: 100%;\r\n    max-height: 24vh;\r\n    overflow-y: auto;\r\n    width: 100%;\r\n    display: none;\r\n    margin-top: 2px;\r\n    box-sizing: border-box;\r\n    transform: translateX(-10px);\r\n    background-color: white;\r\n    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);\r\n    border-radius: 0px 0px 4px 4px;\r\n}\r\n.new-dashboard-property-component .customers-browser-container.active{\r\n    display: block;\r\n}\r\n.new-dashboard-property-component .customers-browser-container div{\r\n    padding: 10px 12px;\r\n    cursor: pointer;\r\n    box-sizing: border-box;\r\n    border-bottom: 1px solid rgb(230, 230, 230);\r\n    transition: background-color 0.25s ease;\r\n}\r\n.new-dashboard-mobile-settings-container{\r\n    padding: 15px;\r\n    border-radius: 5px;\r\n    border: 1px solid lightgray;\r\n}\r\n.new-dashboard-mobile-settings-container h4{\r\n    margin: 0px;\r\n    font-weight: 600;\r\n}\r\n.new-dashboard-mobile-settings-container .hide-dashboard-container{\r\n    display: flex;\r\n    align-items: center;\r\n    padding-top: 16px;\r\n    margin-bottom: 0px;\r\n    padding-bottom: 0px;\r\n}\r\n.new-dashboard-mobile-settings-container .hide-dashboard-container p{\r\n    margin: 0px;\r\n}\r\n.new-dashboard-property-component .mobile-order-entry-container input{\r\n    font-size: 14px;\r\n    padding-top: 4px;\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .header{\r\n    color: rgb(112, 112, 112);\r\n    font-size: 14px;\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .body{\r\n    display: grid;\r\n    grid-template-columns: 100px auto;\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container div{\r\n    box-shadow: 0px 0px 1px rgb(97, 97, 97);\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .image-container{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .image-container img{\r\n    max-width: 80px;\r\n    max-height: 80px;\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .upload-controls-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 6px 10px;\r\n    padding: 10px 0px;\r\n    cursor: pointer;\r\n    align-items: center;\r\n    justify-content: center;\r\n    box-sizing: border-box;\r\n    transition: background-color 0.25s ease;\r\n    box-shadow: 0px 0px 1px rgb(97, 97, 97);\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .upload-controls-container.inactive{\r\n    display: none;\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .upload-controls-container:hover{\r\n    background-color: rgb(248, 248, 250);\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .upload-controls-container img{\r\n    height: 40px;\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .upload-controls-container p{\r\n    margin: 4px 0px;\r\n    font-size: 14px;\r\n    color: rgb(48, 48, 48);\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .uploaded-controls-container{\r\n    padding: 10px 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    border: none;\r\n    box-shadow: none;\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .uploaded-controls-container.inactive{\r\n    display: none;\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .uploaded-controls-container div{\r\n    box-shadow: none;\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .uploaded-controls-container div p{\r\n    margin: 0px;\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .uploaded-controls-container .image-name-p{\r\n    font-size: 14px;\r\n    color: rgb(90, 90, 90);\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .uploaded-controls-container .image-size-p{\r\n    font-size: 13px;\r\n    color: rgb(145, 145, 145);\r\n}\r\n.new-dashboard-mobile-settings-container .dashboard-image-container .uploaded-controls-container .remove-image-p{\r\n    cursor: pointer;\r\n    color: rgb(100, 100, 100);\r\n}\r\n.new-dashboard-container-buttons{\r\n    width: 100%;\r\n    padding: 20px 50px;\r\n    padding-right: 13px;\r\n    text-align: right;\r\n    box-sizing: border-box;\r\n}\r\n.new-dashboard-container-buttons button{\r\n    padding: 10px 25px;\r\n    margin: 0px 10px;\r\n    border-radius: 5px;\r\n    border: none;\r\n    cursor: pointer;\r\n    color: white;\r\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    transition: opacity 0.2s ease;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.new-dashboard-container-buttons button:hover{\r\n    opacity: 0.9;\r\n}\r\n.new-dashboard-container-buttons button.inactive{\r\n    opacity: 0.6;\r\n    box-shadow: none;\r\n    cursor: not-allowed;\r\n    color: rgb(136, 136, 136);\r\n    background-color: rgb(201, 201, 201);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
